import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Capacitor } from "@capacitor/core";

const COOKIE_CONSENT_KEY = "cookie-consent";

const isElectron =
  typeof window !== "undefined" &&
  (window.electronAPI !== undefined || window.navigator.userAgent.includes("Electron"));

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (isElectron || Capacitor.isNativePlatform()) return;
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) setVisible(true);
  }, []);

  const handleConsent = (choice: "all" | "essential") => {
    localStorage.setItem(COOKIE_CONSENT_KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="mx-auto max-w-3xl rounded-lg border border-border bg-card p-4 shadow-lg flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <p className="text-sm text-muted-foreground flex-1">
          {t("cookieBanner.message", "We use essential cookies for core functionality and optional cookies to improve your experience.")}{" "}
          <a href="/privacy-policy" className="underline text-primary hover:text-primary/80 transition-colors">
            {t("cookieBanner.learnMore", "Learn more about our privacy policy")}
          </a>
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={() => handleConsent("essential")}>
            {t("cookieBanner.essentialOnly", "Essential only")}
          </Button>
          <Button size="sm" onClick={() => handleConsent("all")}>
            {t("cookieBanner.acceptAll", "Accept all")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
